import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const PROJECT_MANAGER_QUERY = gql`
  query GetProjectManager($projectId: String!) {
    project(projectId: $projectId) {
      id
      projectManagerReference {
        uri
      }
    }
  }
`;

export const useProjectManager = ({ projectId }) => {
  const { data, loading } = useQuery(PROJECT_MANAGER_QUERY, {
    skip: !projectId,
    variables: { projectId },
    fetchPolicy: 'network-only'
  });

  const projectManagerUri = data?.project?.projectManagerReference?.uri;

  return {
    loading,
    projectManagerUri
  };
};

export default useProjectManager;
